module.exports = "<a href = '{{url}}' class=\"groups-link\">{{displayName}}</a>";